import {List, Map, fromJS} from 'immutable';
import {REQUEST, STATE} from '../constants/index';

/**
 * @private
 * @desc Returns an object of props used by the request reducer for FETCHING and MESSAGES logic
 * @param state
 * @param serviceType
 * @param fetchingKey
 * @param stateKey
 * @returns {Object}
 */
function getReqObjByType(state, serviceType, fetchingKey, stateKey) {
  const path = stateKey[`${serviceType}`];
  const services = stateKey[`${serviceType}_SERVICES`];
  const current = state.getIn(services);
  let index, exists;
  if (typeof current.indexOf === 'function') {
    index = current.indexOf(fetchingKey);
    exists = index !== -1;
  } else {
    exists = current.get(fetchingKey, null) !== null;
  }
  return {path, services, current, index, exists};
}

/**
 * @private
 * @desc A wrapper around getReqObjByType
 * @param state
 * @param action
 * @returns {*}
 */
function getReqObjects(state, action) {
  const keys = ['FETCHING', 'MESSAGES'];
  const {serviceType, fetchingKey} = action;
  return [
    REQUEST.REQUEST_START,
    REQUEST.REQUEST_ERROR,
    REQUEST.REQUEST_SUCCESS,
    REQUEST.REQUEST_COMPLETE
  ].indexOf(action.type) !== -1 ?
    keys.reduce((obj, key) => Object.assign(obj, {[key]: getReqObjByType(state, serviceType, fetchingKey, STATE[key])}), {}) : {};
}

/**
 * General action handling for request state updates
 * @param {Object} state An immutable state object to check against
 * @param {Object} action Data to update the redux store state
 * @returns {Object} A (usually changed) immutable state object
 */
export default function (state = Map(), action = null) {
  const {FETCHING, MESSAGES} = getReqObjects(state, action);
  switch (action.type) {
    case REQUEST.REQUEST_START: {
      if (Array.isArray(action.statePath) && action.clearStateOnRequest) state = state.setIn(action.statePath, Map());
      if (action.clearMessagesOnRequest) {
        state = state.setIn(MESSAGES.path, List());
        if (MESSAGES.exists) state = state.removeIn(MESSAGES.services.concat([action.fetchingKey]));
      }
      if(action.cancelFetching) return state;
      if (!FETCHING.exists) state = state.setIn(FETCHING.services, FETCHING.current.push(action.fetchingKey));
      return state.setIn(FETCHING.path, true);
    }

    case REQUEST.REQUEST_ERROR: {
      const messages = List(action.messages);
      state = state.setIn(MESSAGES.services.concat([action.fetchingKey]), messages);
      return state.setIn(MESSAGES.path, messages);
    }

    case REQUEST.REQUEST_SUCCESS: {
      return state.setIn(action.statePath, fromJS(action.resp));
    }

    case REQUEST.REQUEST_COMPLETE: {
      if (FETCHING.exists) {
        const current = FETCHING.current.splice(FETCHING.index, 1);
        state = state.setIn(FETCHING.services, current);
        return state.setIn(FETCHING.path, current.toJS().length !== 0);
      }
      return state;
    }

    case REQUEST.UPDATE_SESSION: {
      const statePath = action.serviceType === REQUEST.CDA ? STATE.CDA.SESSION.CURRENT_PATH : STATE.SESSION;
      return state.setIn(statePath, fromJS(action.session));
    }

    default:
      return state;
  }
}
